import { OrderFormInfoData, RequisitionFormData, TestType } from '@/types/RequisitionFormTypes'
import { getPatientInfoFromForm } from '@/utils/orderFormUtils'
import React from 'react'

interface OrderSummaryProps {
  orderId?: string
  orderData?: OrderFormInfoData
  formData?: RequisitionFormData | null
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ orderId, orderData, formData }) => {
  const getTestTypeDisplay = () => {
    if (!formData?.order?.selectedOption) return 'Unknown'
    switch (formData.order.selectedOption) {
      case TestType.urWGS_Patient_Only:
        return 'urWGS Proband Only (Singleton)'
      case TestType.urWGS_Duo:
        return 'urWGS Duo (Proband + One biological parent)'
      case TestType.urWGS_Trio:
        return 'urWGS Trio (Proband + Mother + Father)'
      case TestType.rWGS_Patient_Only:
        return 'Rapid WGS - Patient Only (rWGS)'
      case TestType.rWGS_Duo:
        return 'Rapid WGS - Duo (rWGS)'
      case TestType.rWGS_Trio:
        return 'Rapid WGS - Trio (rWGS)'
      default:
        return formData.order.selectedOption
    }
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <h3 className="page-navigation-title mb-4">Order Details</h3>
      <dl className="space-y-3">
        <div>
          <dt className="form-label">Order ID</dt>
          <dd className="body-text mt-1 font-mono font-semibold text-gray-900">{orderId}</dd>
        </div>
        <div>
          <dt className="form-label">Patient Name</dt>
          <dd className="body-text mt-1">
            {getPatientInfoFromForm(orderData ?? null).name || 'N/A'}
          </dd>
        </div>
        <div>
          <dt className="form-label">MRN</dt>
          <dd className="body-text mt-1">{orderData?.patient?.mrn || 'N/A'}</dd>
        </div>
        <div>
          <dt className="form-label">Test Type</dt>
          <dd className="body-text mt-1">{getTestTypeDisplay()}</dd>
        </div>
        <div>
          <dt className="form-label">Order Date</dt>
          <dd className="body-text mt-1">
            {orderData?.orderDate
              ? new Date(orderData.orderDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })
              : 'N/A'}
          </dd>
        </div>
      </dl>
    </div>
  )
}

export default OrderSummary
